import styled, { css } from 'styled-components'

import { OUTLINE_COLOR } from '@CSSVars/colors'


export const separatorLineStyle = css`
  width: 100%;
  height: 1px;
  background: ${OUTLINE_COLOR};
`

export const _Line = styled.div`
  ${separatorLineStyle};
  margin: 48px 0 24px 0;

  @media screen and (max-width: 1023px) {
    margin: 24px 0;
  }
`
